import React from 'react';
import ClassNames from 'classnames';
import { arrayOf, node, number, shape, string } from 'prop-types';

import './Toast.scss';

const Toast = ({ className, stack }) => {
  return (
    <div className={ClassNames('toast', 'toast--bottom-right', className)}>
      {stack.map(row => (
        <div
          key={row.id}
          className={ClassNames(
            `toast-entry toast-entry--${row.type ||
              'primary'} toast-entry--fade text --small --p-md --mt-md`
          )}
        >
          <div className="toast-entry__content">{row.content}</div>
          {row.action}
        </div>
      ))}
    </div>
  );
};

Toast.propTypes = {
  className: string,
  stack: arrayOf(
    shape({
      type: string,
      content: node,
      duration: number
    })
  ).isRequired
};

Toast.defaultProps = {
  className: null
};

export default Toast;
